module.exports = __webpack_public_path__ + "static/assets/fc0fa4a32cbdf870a67195fb24bb2675.png";